import axios from "axios";
import { installOffline } from "../offline/interceptors";

export const API = `${window.location.origin}/api/field`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("auth_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

installOffline("field", api);   // FLD-OFF — cache reads, queue writes, client write ids
if (typeof window !== "undefined") window.__absFieldApi = api;   // QA harness: drive the offline queue from the console

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !String(err.config?.url || "").includes("/auth/")) {
      localStorage.removeItem("auth_token");
      window.dispatchEvent(new Event("fieldops-unauthorized"));
    }
    return Promise.reject(err);
  }
);

// Same colours as before, expressed as utilities so the app's dark sheet maps them.
export const STATUS_PILL = {
  draft:        { cls: "bg-gray-100 text-gray-600 border-gray-200", label: "Draft" },
  not_ready:    { cls: "bg-gray-100 text-gray-600 border-gray-200", label: "Not Ready" },
  none:         { cls: "bg-gray-50 text-gray-400 border-gray-100", label: "—" },
  requested:    { cls: "bg-sky-100 text-sky-700 border-sky-200", label: "Requested" },
  ready:        { cls: "bg-sky-100 text-sky-700 border-sky-200", label: "Ready" },
  needs_review: { cls: "bg-orange-100 text-orange-700 border-orange-200", label: "Needs Review" },
  scheduled:    { cls: "bg-blue-100 text-blue-700 border-blue-200", label: "Scheduled" },
  s_pool:       { cls: "bg-amber-100 text-amber-800 border-amber-200", label: "Sch Pool" },
  d_pool:       { cls: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200", label: "Dsp Pool" },
  ready_to_dispatch: { cls: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200", label: "Dsp Pool" },
  dispatched:   { cls: "bg-teal-100 text-teal-700 border-teal-200", label: "Dispatched" },
  completed:    { cls: "bg-green-100 text-green-700 border-green-200", label: "Completed" },
  active:       { cls: "bg-green-100 text-green-700 border-green-200", label: "Active" },
  cancelled:    { cls: "bg-red-100 text-red-700 border-red-200", label: "Cancelled" },
};

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return s;
  }
}

export function toISODate(d) {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toISOString().slice(0, 10);
}

export function startOfWeek(d) {
  const x = new Date(d);
  const day = x.getDay(); // 0=Sun
  const diff = (day === 0 ? -6 : 1 - day); // Monday start
  x.setDate(x.getDate() + diff);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}
